const searchURLs = {
    lorillard: {
        public: 'https://prdrjrdocs.search.windows.net/indexes/lorillard-public/docs/search?api-version=2017-11-11',
        privilege: 'https://prdrjrdocs.search.windows.net/indexes/lorillard-privilege/docs/search?api-version=2017-11-11',
        confidential: 'https://prdrjrdocs.search.windows.net/indexes/lorillard-confidentiality/docs/search?api-version=2017-11-11',
        fourb: 'https://prdrjrdocs.search.windows.net/indexes/lorillard-4b/docs/search?api-version=2017-11-11',
    },
    rjr: {
        public: 'https://prdrjrdocs.search.windows.net/indexes/rjr-public/docs/search?api-version=2017-11-11',
        privilege: 'https://prdrjrdocs.search.windows.net/indexes/rjr-privilege/docs/search?api-version=2017-11-11',
        confidential: 'https://prdrjrdocs.search.windows.net/indexes/rjr-confidentiality/docs/search?api-version=2017-11-11',
        fourb: 'https://prdrjrdocs.search.windows.net/indexes/rjr-4b/docs/search?api-version=2017-11-11'
    },
    atco: {
        public: 'https://prdrjrdocs.search.windows.net/indexes/atco-public/docs/search?api-version=2017-11-11',
        privilege: 'https://prdrjrdocs.search.windows.net/indexes/atco-privilege/docs/search?api-version=2017-11-11',
        confidential: 'https://prdrjrdocs.search.windows.net/indexes/atco-confidentiality/docs/search?api-version=2017-11-11',
        fourb: 'https://prdrjrdocs.search.windows.net/indexes/atco-4b/docs/search?api-version=2017-11-11'
    },
    bw: {
        public: 'https://prdrjrdocs.search.windows.net/indexes/bw-public/docs/search?api-version=2017-11-11',
        privilege: 'https://prdrjrdocs.search.windows.net/indexes/bw-privilege/docs/search?api-version=2017-11-11',
        confidential: 'https://prdrjrdocs.search.windows.net/indexes/bw-confidentiality/docs/search?api-version=2017-11-11',
        fourb: 'https://prdrjrdocs.search.windows.net/indexes/bw-4b/docs/search?api-version=2017-11-11'
    },
    courtaction: {
        courtaction: 'https://prdrjrdocs.search.windows.net/indexes/azuresql-index/docs/search?api-version=2017-11-11'
    }
};

const staticAssetURLs = {
    bw: {
        public: 'https://prdrjrdocs.blob.core.windows.net/bwpublic/'
    },
    rjr: {
        public: 'https://prdrjrdocs.blob.core.windows.net/rjrpublic/'
    },
    atco: {
        public: 'https://prdrjrdocs.blob.core.windows.net/atcopublic/'
    },
    lorillard: {
        public: 'https://prdrjrdocs.blob.core.windows.net/lorillardpublic/'
    },
    courtaction: {
        public: 'https://prdrjrdocs.blob.core.windows.net/courtaction/'
    }
};

const searchApiKey = '93D64E0937B82B4781BD91855BF94639';

const paginationSettings = {
    numberOfItemsPerPage: 10,
    maxNumberVisiblePaginationTabs: 5
};

/* set up Azure AD tenant info for Dev and Prod. You need to have a valid app registration on the Azure tenant to get these values */

const adalConfigDev = {
    tenant: 'f0515eb8-2ee9-49f5-b180-20768b2fadcc',
    clientId: '1b045f17-13d4-4106-9798-90cfd5ed39b4',
    cacheLocation: 'localStorage',
    redirectUri: 'http://localhost:3000',
    AZURE_REDIRECT_URL: 'https://localhost:3000/auth/openid/return'
};

const adalConfigProd = {
    tenant: 'f0515eb8-2ee9-49f5-b180-20768b2fadcc',
    clientId: 'd5f0b1ca-744a-454c-9a6b-1d52049a1039',
    cacheLocation: 'localStorage',
    redirectUri: 'https://azrjrdocwebapp02.azurewebsites.net',
    AZURE_REDIRECT_URL: 'https://azrjrdocwebapp02.azurewebsites.net'
    };

export const RJRTSearchURLS = searchURLs;
export const RJRTStaticAssetURLs = staticAssetURLs;
export const RJRTPaginationSettings = paginationSettings;
export const RJRTSearchAPIKey = searchApiKey;
export const RJRTADALConfigDev = adalConfigDev;
export const RJRTADALConfigProd = adalConfigProd;


// WEBPACK FOOTER //
// ./src/config.js